"use strict";

import angular from "angular";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting.group.demonstrations.fin", {
        url: "/demonstracoes/financeiro",
        views: {
            "demonstrationView@nucont.accounting.group.demonstrations": {
                component: "financialDemonstrationsComponent",
                bindings: { companyData: "groupData" }
            }
        },
        params: {
            source: { value: "financeiro", dynamic: true }
        }
    });
}
